import Employee from '@/api/employee'
import LeaveSummary from '@/api/leave-summary'

export const getters = {}
export const actions = {
  getEmployee (context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_staff_information: 'staff_id,name_en,name_kh'
      },
      ...attributes
    }
    return Employee.get({
      params: params,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLeaveType (context, data) {
    return LeaveSummary.leaveType(data)
  },

  previewPdf (context, attributes = {}) {
    return LeaveSummary.previewPdf({ params: attributes })
  },
  exportExcel (context, payload) {
    return LeaveSummary.exportExcel(payload)
  }
}
